// src/components/About/About.js
import React from 'react';
import './About.css';

function About() {
    return (
        <section id="about" className="about" aria-labelledby="about-title">
            <div className="container">
                <div className="about-layout">
                    <div className="about-heading">
                        <p className="section-kicker">Откуда этот рисунок</p>
                        <h2 id="about-title">Наличники переехали с фасада на футболку.</h2>
                    </div>
                    <div className="about-copy">
                        <p>
                            Мы берём узнаваемую геометрию резных наличников и переводим
                            её на язык современной повседневной одежды. Без музейной
                            стилизации — спокойно, точно и на каждый день.
                        </p>
                        <p>
                            «ЭТО РОССИЯ» — бренд о культуре, которую можно не только
                            помнить, но и носить.
                        </p>
                    </div>
                </div>
                <div className="about-principles" aria-label="Принципы коллекции">
                    <div><span>01</span><strong>Россия в деталях</strong><p>Наличники, молоко, борщ и узнаваемые сюжеты.</p></div>
                    <div><span>02</span><strong>Честные ракурсы</strong><p>Спереди, сзади и крупные детали.</p></div>
                    <div><span>03</span><strong>Размеры XS–XXL</strong><p>Реальный остаток виден перед заказом.</p></div>
                </div>
            </div>
        </section>
    );
}

export default About;
